import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import WeelodgeInfoContent from './WeelogeInfoContent';
import { WEELODGE_STATUS } from '../proptype/weelodgeMetadata';

const WeelodgeHistoryItem = ({ t, status, value }) => {
  let label = `${t('weelodge.modal.date.deed_signed')}:`;
  if (status === WEELODGE_STATUS.FULL_TREATED) {
    label = `${t('weelodge.modal.date.deed_planned')}:`;
  }
  return (
    <div>
      <div className="badge-history">
        <div className={`badge badge-${status}`} />
        <span>{t(`weelodge.modal.status.${status}`)}</span>
      </div>
      <div className="history-date-container">
        <WeelodgeInfoContent label={label} value={value} />
      </div>
    </div>
  );
};

WeelodgeHistoryItem.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

WeelodgeHistoryItem.defaultProps = {
};

export default translate(WeelodgeHistoryItem);
